var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.4 0C.6 0 0 .6 0 1.4v9.3c0 .7.6 1.3 1.4 1.3h6.9c.7 0 1.3-.6 1.3-1.3V4.4L9.5 4 5.5.1 5.3 0H1.4Zm0 .9h3.4v2.6c0 .7.6 1.3 1.4 1.3h2.5v5.9c0 .2-.2.4-.4.4h-7a.4.4 0 0 1-.4-.4V1.3c0-.3.2-.5.5-.5Zm4.3.6L8.1 4H6a.4.4 0 0 1-.4-.4v-2ZM2.8 6.3a.5.5 0 1 0 0 .9h4a.5.5 0 1 0 0-.9h-4Zm0 2.1a.5.5 0 1 0 0 .9h2.8a.5.5 0 1 0 0-.9H2.8Z",
  fill: "#185A7D"
})));
export default SvgFile;